export default "__VITE_ASSET__b6a38c45__"